// this is an autogenerated file from App/Account/Content/Settings/Content/ConnectApps/App/Content/Connections/Content/ActionsColumn/ToggleLocationConnection/SetupAutomations/Content/Content/Content/Steps/Content/ActiveStep/Automation/Event/AppointmentBookingStateUpdate/AppointmentType/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Settings_Content_ConnectApps_App_Content_Connections_Content_ActionsColumn_ToggleLocationConnection_SetupAutomations_Content_Content_Content_Steps_Content_ActiveStep_Automation_Event_AppointmentBookingStateUpdate_AppointmentType($location_id: uuid!) {
  vaxiom_appointment_templates(
    where: {
      deleted: { _eq: false }
      organization: { _id: { _eq: $location_id } }
    }
    order_by: { full_name_computed: asc }
  ) {
    id
    appointment_type_id
    text: full_name_computed
    appointment_type {
      id
      _id
      name
    }
  }
}

`